<template>
    <table class="client1-table table-format set_column_width table table-striped table-bordered dt-responsive nowrap" v-bind:id=id style="width:100% !important" cellspacing="0">
        <thead>
        <tr>
            <th v-if="showClient" scope="col" style="width: 200px">Client</th>
            <th v-if="showOrder" scope="col">Order</th>
            <th scope="col">#</th>
            <th scope="col">Invoice Date</th>
            <th scope="col">Period</th>
            <th scope="col" v-show="false">Rental Fee</th>
            <th scope="col" v-show="false">Discount</th>
            <th scope="col" v-show="false">Ads Package</th>
            <th scope="col">Total (inc. VAT)</th>
            <th scope="col">Credit (inc. VAT)</th>
            <th scope="col">Balance (inc. VAT)</th>
            <th scope="col">Imported</th>
        </tr>
        </thead>
        <tbody>
            <template v-for="(invoice, idx) in invoices">
                <tr>
                    <td v-if="showClient">
                        {{ invoice.client.name }} ({{ invoice.client.organization.name }})
                        <vbutton
                            v-if="isOverdue(invoice) && isPayable(invoice)"
                            v-on:click="pay(invoice)"
                            class="btn-primary payInvoice"
                            :disabled="isLoading || invoice.loading"
                            :loading="invoice.loading"
                            :text="'Pay'">
                        </vbutton>
                    </td>
                    <td v-if="showOrder">
                        <a v-if="invoice.order" :href="`/orders/${invoice.order.number}`"
                           target="_blank">{{ invoice.order.number }}</a>
                    </td>
                    <td>
                        <a :href="`/billing/print/${invoice.external_id}`">{{ invoice.number }}</a>
                    </td>
                    <td>
                        {{ invoice.invoice_date | formatDate }}
                    </td>
                    <td>
                        {{ invoice.invoice_period_start | formatDate }} - {{ invoice.invoice_period_end | formatDate }}
                    </td>
                    <td v-show="false">
                        {{ invoice.rental_fee }} {{ getCurrency(invoice) }}
                    </td>
                    <td v-show="false">
                        {{ invoice.discount }}%
                    </td>
                    <td v-show="false">
                        {{ invoice.ads_package }} {{ getCurrency(invoice) }}
                    </td>
                    <td>
                        {{ invoice.total }} {{ getCurrency(invoice) }}
                    </td>
                    <td>
                        <span v-if="invoice.credited_amount > 0">{{ invoice.credited_amount }} {{ getCurrency(invoice) }}</span>
                    </td>
                    <td>
                        <span v-if="invoice.is_cancelled === true" class="paid-btn proxima-nova-bold text-secondary">
                            CANCELLED
                        </span>
                        <span v-else-if="invoice.balance === 0" class="paid-btn text-success proxima-nova-bold">
                            PAID
                        </span>
                        <span v-else-if="invoice.total === invoice.credited_amount" class="paid-btn proxima-nova-bold text-secondary">
                            CREDITED
                        </span>
                        <div v-else class="balance" :class="{
                            'due': (new Date(invoice.due_date)).setHours(0,0,0,0) == (new Date()).setHours(0,0,0,0),
                            'overdue': isOverdue(invoice)
                        }">
                            <span style="display: block">{{ invoice.balance }} {{ getCurrency(invoice) }}</span>
                            <span>due {{ invoice.due_date | formatDate }}</span>
                            <p v-if="invoice.payment_error_message">
                                <b>Stripe error:</b><br>
                                <span>{{invoice.payment_error_message}}</span>
                            </p>
                        </div>
                    </td>
                    <td>
                        <span v-if="invoice.imported_at">{{ invoice.imported_at | formatDate }}</span>
                    </td>

                </tr>
                <tr v-for="(creditNote, idx) in invoice.credit_notes" style="background-color: #f5f5f5">
                    <td v-if="showClient">
                    </td>
                    <td v-if="showOrder">
                    </td>
                    <td>
                        <a :href="`/billing/print/${creditNote.external_id}`">{{ creditNote.number }}</a>
                    </td>
                    <td>
                        {{ creditNote.invoice_date | formatDate }}
                    </td>
                    <td></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td>
                        {{ creditNote.total }} {{ getCurrency(invoice) }}
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                        <span v-if="creditNote.imported_at">{{ creditNote.imported_at | formatDate }}</span>
                    </td>
                    <td></td>
                </tr>
            </template>
        </tbody>
    </table>
</template>

<script>

//Bootstrap and jQuery libraries
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import $ from 'jquery';
import 'datatables.net-responsive-dt'

// import axios from 'axios';

import moment from 'moment';

export default {
    props: ['invoices', 'showClient', 'showOrder','id'],

    mounted() {
        // if (this.invoices) {
        //   this.invoices.forEach(invoice => {
        //       invoice.loading = false;
        //   });
        // }

        if(this.id == "od-inv-dt-table" && !$.fn.DataTable.isDataTable('#due-inv-dt-table') )
            $('#od-inv-dt-table').DataTable({responsive: true});
    },

    updated(){

        if (!$.fn.DataTable.isDataTable('#due-inv-dt-table') )
        {
            $('#due-inv-dt-table').DataTable({responsive: true});
        }

        if (!$.fn.DataTable.isDataTable('#cli-inv-dt-table') )
        {
            $('#cli-inv-dt-table').DataTable({responsive: true});
        }

    },

    watch: {
        invoices() {

            if ($.fn.DataTable.isDataTable('#cli-inv-dt-table') )
            {
                $("#cli-inv-dt-table").DataTable().destroy();
            }

            // this.invoices.forEach(invoice => {
            //     invoice.loading = false;
            // });

        },
    },
    computed: {
        isLoading() {
            return this.invoices.filter(invoice => invoice.loading === true).length > 0;
        },
    },
    methods: {
        getCard(invoice) {
            return invoice.client.cards.find(card => card.default == true || card.default == 1);
        },
        pay(invoice) {
            if (confirm('Are you sure you want to pay the invoice?')) {
                invoice.loading = true;
                axios.post('/invoices/pay', {id: invoice.id}).then((res) => {
                    invoice.balance = res.data.balance;
                    invoice.loading = false;
                }).catch(err => {
                    console.log(err);
                    invoice.loading = false;
                });
            }
        },

        getCurrency(invoice) {
            if (invoice.order) {
                return invoice.order.currency;
            } else if (invoice.client.location.toLowerCase() === 'united kingdom') {
                return 'GBP';
            } else if (invoice.client.location.toLowerCase() === 'sweden') {
                return 'SEK';
            }
        },
        isOverdue(invoice) {
            return (new Date(invoice.due_date)).setHours(0,0,0,0) < (new Date()).setHours(0,0,0,0);
        },
        isPayable(invoice) {
            return invoice.balance > 0
                && this.getCard(invoice)
                && (!invoice.order || invoice.order.contract_status.toLowerCase() !== 'terminate');
        }
    },
    filters: {
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD');
        }
    },

     data: function () {
         return {

        };
    }
}
</script>

<style scoped>
    .balance.due {
        color: orange;
    }
    .balance.overdue {
        color: red;
    }
    .payInvoice{
display: block;
    }
</style>
